import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';
import { CONFIG } from '../../../meta/types/config';
import { RoleAssignmentGroup } from '../../../meta/types/user';

const { GET } = api;

const ROLE_RESOURCE_BASE_PATH = `${CONFIG.identityServiceBasePath}/oauth/roles`;

export interface RoleResource {
  getRoleAssignmentGroup: ResourceFetch<RoleAssignmentGroup, { groupId: number }>;
}

const RoleResource: RoleResource = {
  getRoleAssignmentGroup: GET(`${ROLE_RESOURCE_BASE_PATH}/assignments/groups/:groupId`),
};

export default RoleResource;
